// extracted by mini-css-extract-plugin
export var directions = "main-page-module--directions--aaqRT";
export var directionsFooter = "main-page-module--directions-footer--dn2Hq";